module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"drone_part.field.serial_no":"S/N","drone_part.field.remark":"หมายเหตุ","drone_part.field.attach_type":"ติดตั้งจาก","drone_part.field.serial_no.no_required":"ไม่มี S/N"}}')
  delete Component.options._Ctor
}
